export const routesData = [
    {
        icon: 'home',
        title: 'Siti',
        tooltip: 'Siti',
        route: 'home'
    },
    {
        icon: 'storage',
        title: 'Stato Sili',
        tooltip: 'Stato Sili',
        route: 'stato-sili'
    },
    {
        icon: 'dashboard',
        title: 'Errori',
        tooltip: 'Errori',
        route: 'errori'
    }
]
